<section class="wrapper">
  <app-left-menu-feature-left-menu></app-left-menu-feature-left-menu>
  <router-outlet [class.menu-block-opened-next]="leftMenuIsOpen$ | async"></router-outlet>
</section>

<app-notice-feature-notice></app-notice-feature-notice>
<app-icons></app-icons>
<app-ui-popover></app-ui-popover>
<app-ui-svg></app-ui-svg>
